import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {IMonsterWalk} from "../server/IData";
import {MonsterSymbol} from "../reels/MonsterSymbol";
import {Sound} from "../sound/Sound";
import { APISetting } from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class BulldozerExplosionRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.bulldozerExplodePosition.x !== -1 && !Game.model.gameData.suspendedAction;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            bulldozerExplodePosition: IMonsterWalk = Game.model.bulldozerExplodePosition,
            bulldozerReel: number = bulldozerExplodePosition.x,
            targetRowId: number = bulldozerExplodePosition.y,
            bulldozerSymbol: MonsterSymbol = Game.reelsView.reelModels[bulldozerReel].getMonsterSymbolAtRowId(targetRowId),
            turnDuration: number = Game.apiPlugin.settings.get(APISetting.FAST_SPIN) ? 0.2/2: 0.2;

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });

            if (bulldozerSymbol && bulldozerSymbol.parent) {
                bulldozerSymbol.parent.addChild(bulldozerSymbol);
            }
        });

        tl.add(bulldozerSymbol.turnMonsterAgainstWall(bulldozerReel, turnDuration));

        tl.addLabel("explosion");
        tl.add(Game.symbolFloors.showExplosionMark(bulldozerExplodePosition.x, bulldozerExplodePosition.y), "<0.2");

        tl.add([
            () => {
                Game.soundPlayer.playSound(Sound.BU_EXPLODE, 1);
            },
            Game.shakeScreen()
        ], "explosion")

        Game.updateSurprisedMonstersInExplosion(bulldozerReel - 1, targetRowId - 1, targetRowId + 2),
        Game.updateSurprisedMonstersInExplosion(bulldozerReel, targetRowId - 1, targetRowId + 2),
        Game.updateSurprisedMonstersInExplosion(bulldozerReel + 1, targetRowId - 1, targetRowId + 2),

        tl.add([
            Game.explodeSymbols(bulldozerReel - 1, targetRowId - 1, targetRowId + 2),
            Game.explodeSymbols(bulldozerReel, targetRowId - 1, targetRowId + 2),
            Game.explodeSymbols(bulldozerReel + 1, targetRowId - 1, targetRowId + 2),
            bulldozerSymbol.playBigExplode(),
        ], "explosion");

        tl.add(() => {
            Game.reelsView.reelModels[bulldozerReel].removeSymbol(bulldozerSymbol)
            bulldozerSymbol.isRemoved = true;

            Game.monsterCarriedSymbols[bulldozerSymbol.monsterIdx].splice(Game.monsterCarriedSymbols[bulldozerSymbol.monsterIdx].indexOf("bu"), 1);
        });

        if (Game.model.data.maxExpansion){
            tl.add(Game.explodeSymbolsBeforeMaxExpansion(), "<0.5");
            tl.add(Game.expandGridForMaxExpansion(), "<0.55");
        }
        
        tl.add(bulldozerSymbol.useWpRemoveFlag("bu"));
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
        Game.soundPlayer.stopSound(Sound.BU_EXPLODE);
    }
}